/**
 * CypAdhdPatientOverviewSkeleton.js
 *
 * Loading skeleton for the CYP ADHD patient overview.
 *
 * The CYP route previously borrowed AutismPatientOverviewSkeleton, which was
 * wrong in two ways at once. It derives its card count from the ADULT AUTISM
 * workflow config — three cards where Behavioural Observation is disabled,
 * four where it is enabled — whereas CYP ADHD always has exactly four. On an
 * org with Observation disabled the skeleton laid out three cards and then
 * reflowed to four, and getAssessmentModuleCardWidthClass picked a different
 * width class for each state, so the cards visibly resized as well as
 * reflowed. It also passed overviewPath="/patient/{id}/adult-autism", so the
 * breadcrumb shown while a CYP patient loaded pointed at the autism overview.
 *
 * The count is read from CYP_ADHD_MODULE_CONFIG rather than written out here,
 * so a stage added to or removed from the overview cannot leave the skeleton
 * behind — which is the same mistake in a different place.
 */
import React from 'react';
import { useParams } from 'react-router-dom';
import PatientOverviewSkeleton from '../components/PatientOverviewSkeleton';
import { CYP_ADHD_MODULE_CONFIG } from './config/cypAdhdModuleConfig';

export default function CypAdhdPatientOverviewSkeleton({ summary }) {
  const { patientId } = useParams();

  return (
    <PatientOverviewSkeleton
      summary={summary}
      moduleCount={CYP_ADHD_MODULE_CONFIG.moduleOrder.length}
      overviewPath={`/patient/${patientId}/cyp-adhd`}
    />
  );
}
